<template>
  <div>
    <quill-editor
      v-model="articleContent"
      ref="myQuillEditor"
      :options="editorOption"
      :style="editHeight"
      @blur="onEditorBlur($event)"
      @focus="onEditorFocus($event)"
      @ready="onEditorReady($event)"
      @change="onEditorChange"
    ></quill-editor>
    <a-modal
      title="插入图片"
      class="avatar-uploader-modal"
      :maskClosable="false"
      :footer="null"
      v-model="modelVisible"
    >
      <a-upload
        :action="imgServeUrl"
        listType="picture"
        :fileList="fileList"
        :headers="headers"
        @change="imgChange"
        class="upload-list-inline"
      >
        <a-button type="dashed" block style="width:100%">
          <a-icon type="upload"/>点击上传
        </a-button>
      </a-upload>
      <a-button type="danger" style="margin-top: 20px;" @click="hideModal">取消</a-button>
    </a-modal>
  </div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import '@/assets/quill-editor.less'
import { quillEditor } from 'vue-quill-editor'
// eslint-disable-next-line
import { uploadImg, deleteImg } from "@/apis/article";
import { storage } from '@/utils/base.js'
import {
  baseURL
} from '@/utils/global.config'

const toolbarOptions = [
  ['bold', 'italic', 'underline', 'strike'], // toggled buttons
  ['blockquote'],
  [
    {
      font: []
    }
  ],
  [
    {
      align: []
    }
  ],

  [
    {
      header: 1
    },
    {
      header: 2
    }
  ], // custom button values
  [
    {
      list: 'ordered'
    },
    {
      list: 'bullet'
    }
  ],
  [
    {
      indent: '-1'
    },
    {
      indent: '+1'
    }
  ], // outdent/indent
  [
    {
      size: ['small', false, 'large', 'huge']
    }
  ], // custom dropdown
  [
    {
      header: [1, 2, 3, 4, 5, 6, false]
    }
  ],

  [
    {
      color: []
    },
    {
      background: []
    }
  ], // dropdown with defaults from theme
  ['link', 'image', 'video'],
  ['clean'] // 清除字体样式
]

export default {
  data () {
    return {
      editorOption: {
        placeholder: '妙笔生花',
        theme: 'snow', // or 'bubble'
        modules: {
          toolbar: {
            container: toolbarOptions,
            handlers: {
              image: this.imageHandle
            }
          }
        }
      },
      /*       editHeight: {
        height: null
      }, */
      modelVisible: false,
      fileList: null,
      imgServeUrl:
        `${baseURL}/ArticleService/ArticleManage/UploadFile`,
      headers: {},
      /* isImg: {
        img: false,
        cursorPostion: 1, //1表示光标在后，0表示光标在前
        currentImg: ""
      }, */
      isCanSelectImg: true // 是否可选择图片，当光标不在编辑器上时不可选择
    }
  },

  components: {
    quillEditor
  },
  computed: {
    articleContent: {
      get: function () {
        return this.content
      },
      set: function () {}
    }
  },
  props: {
    content: String,
    editHeight: Object
  },
  methods: {
    onEditorBlur (e) {
      // console.log(this.content);
    },
    onEditorFocus (e) {
      // console.log(e);
    },
    onEditorReady (e) {
      // console.log(e);
    },
    // 上传文件
    imgChange (info) {
      this.fileList = info.fileList
      if (info.file.status === 'uploading') {
        // console.log(info);
      }
      if (info.file.status === 'done') {
        this.$message.success(`${info.file.name} 上传成功`)
        let quill = this.$refs.myQuillEditor.quill
        // console.log(quill.getSelection());
        let length = quill.getSelection().index
        quill.insertEmbed(length, 'image', info.file.response.attribute)
        // 调整光标到最后
        quill.setSelection(length + 2)
        this.modelVisible = false
        this.fileList.length = 0
        let imgs = document.getElementsByTagName('img')
        for (let index = 0; index < imgs.length; index++) {
          const element = imgs[index]
          element.addEventListener('click', function (element, e) {
            /* let content = quill.getContents().ops;
            for (let m = 0; m < content.length; m++) {
              const element = content[m];
              if (
                content.insert.image &&
                content.insert.image == element.target.src
              ) {
              }
            }
            console.log(quill.getContents(), element.target.src); */
          })
        }
        this.isAddImg = true
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} 上传失败`)
      }
    },

    // 当编辑器类容变化时
    onEditorChange (e) {
      this.$emit('onEditorChange', e.html, e.text)
    },

    // 显示上传图片modal
    imageHandle (value) {
      if (value && this.isCanSelectImg) {
        this.modelVisible = true
      } else {
        // this.quill.format("image", false);
      }
    },
    // 隐藏modal
    hideModal () {
      this.modelVisible = false
    },
    // 删除图片
    delImg () {
      deleteImg(this.isImg.currentImg)
    }
  },
  mounted () {
    // let that = this;
    this.headers = {
      Authorization: 'Bearer ' + storage.get('token')
    }

    /* this.editHeight.height = `${window.innerHeight - 104}px`;
    window.onresize = () => {
      Vue.set(this.editHeight, "height", `${window.innerHeight - 104}px`);
      // this.articleListHeight = window.innerHeight;
      //this.editHeight.height = `${window.innerHeight - 104}px`;
    }; */

    /* let quill = this.$refs.myQuillEditor.quill;
    quill.on("selection-change", function(range, oldRange, source) {
      if (range) {
        if (range.length == 0) {
          let contenta = quill.getContents(range.index, 1);
          let contentb = quill.getContents(range.index - 1, 1);
          if (contenta.ops[0].insert.image) {
            this.isImg = {
              img: true,
              cursorPostion: 0,
              currentImg: contenta.ops[0].insert.image
            };
          } else if (contentb.ops[0].insert.image) {
            this.isImg = {
              img: true,
              cursorPostion: 1,
              currentImg: contentb.ops[0].insert.image
            };
          } else {
            this.isImg = {
              img: false,
              cursorPostion: 0,
              currentImg: ""
            };
          }
        } else {
          var text = quill.getText(range.index, range.length);
          console.log("User has highlighted", text);
        }
      } else {
        that.isCanSelectImg = false;
        //console.log("Cursor not in the editor");
      }
    }); */

    /*    quill.keyboard.addBinding({ key: "backspace" }, function() {
      debugger;
      if (that.isImg.img && that.isImg.cursorPostion) {
        this.delImg();
      }
    });

    quill.keyboard.addBinding({ key: "delete" }, function() {
      debugger;
      if (that.isImg.img && !that.isImg.cursorPostion) {
        this.delImg();
      }
    }); */
  }
}
</script>

<style>
</style>
